<script lang="ts" setup>
import Button from '@autobid/ui/components/elements/button/Button.vue'
import { Menu, MenuButton, MenuItems, TransitionRoot } from '@headlessui/vue'

interface Props {
  buttonClass?: string
}

defineProps<Props>()
</script>

<template>
  <Menu v-slot="{ ...values }" class="relative w-full" as="div">
    <div class="w-full min-w-[200px]">
      <MenuButton
        background-color="var(--color-primary-dark)"
        type="block"
        class="flex w-full items-center justify-between gap-4 !px-4 active:!scale-100"
        :class="buttonClass ?? undefined"
        :as="Button"
      >
        <slot v-bind="values" />
        <Icon
          mode="svg"
          name="fa6-solid:chevron-down"
          :class="values.open ? 'rotate-180' : ''"
          class="text-2xl transition-transform"
        />
      </MenuButton>
    </div>
    <TransitionRoot
      leave="transition ease-in duration-100"
      leave-from="opacity-100"
      leave-to="opacity-0"
    >
      <MenuItems
        class="absolute z-20 mt-1 flex max-h-60 w-full flex-col overflow-y-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
      >
        <slot name="items" v-bind="values" />
      </MenuItems>
    </TransitionRoot>
  </Menu>
</template>
